import { type FunctionalComponent, h } from '@stencil/core';
import { imagePlaceholder } from '../../../../../variables';

interface IDashboardTileSkeleton {
  span?: number;
  picturePlaceholder?: boolean;
}

export const DashboardTileSkeleton: FunctionalComponent<IDashboardTileSkeleton> = ({ picturePlaceholder = true,span = 1 }) => (
  <div class="desktop search-skeleton-container">
    <div class="search-skeleton__item"></div>
    {[...Array(span)].map((_, blockIndex) => (
      <div class="search-skeleton__block" key={blockIndex}>

        {[...Array(2)].map((_, sectionIndex) => (
          <div class="search-skeleton__section" key={sectionIndex}>
            {picturePlaceholder && (
              <img
                class="skeleton__image"
                src={imagePlaceholder}
                width={100}
                height={100}
                alt="image placeholder"
              />
            )}
            <div class="search-skeleton">
              <div class="search-skeleton__item"></div>
              <div class="search-skeleton__item"></div>
              <div class="search-skeleton__item"></div>
            </div>
          </div>
        ))}
      </div>
    ))}
  </div>
);
